exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".precise-scroller-line{display:inline-block;white-space:nowrap;font-family:OratorStd!important}.precise-scroller{overflow:hidden;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/styles/PreciseScroller.css
// module id = 724
// module chunks = 0